<!------------------------------------------------------------------------------
- Copyright (c) 2019. BMW Group. All rights reserved.
----------------------------------------------------------------------------->

<div class="chip-input-wrapper" data-cy="chip-input-wrapper">
  <p [attr.data-cy]="titleDataCy" class="title">{{inputLabel}}</p>

  @if (hasSelectedChips) {
    <button (click)="clickSelectedButton()"
      [disabled]="!state.hasSelectedArrow"
      class="selected-button"
      data-cy="chip-input-selected-button">
      @if (state?.hasSelectedArrow) {
        <span
          [class]="selectedArrowClass"
        data-cy="chip-input-selected-button-arrow"></span>
      }
      <span data-cy="chip-input-selected-button-label">{{selectedLabel}}</span>
    </button>
  }

  @if (showChipList) {
    <div #chipList [ngStyle]="chipListHeight()"
      class="chip-list-wrapper"
      data-cy="chip-input-chip-list">
      @for (chip of state.chips; track chip) {
        <span #chip class="chip">
          <app-chip (chipDelete)="onChipDelete($event)"
            [baseDataCy]="chipDataCy"
            [labelTransform]="$safeNavigationMigration(chipInputConfiguration?.chipLabelTransform)"
            [tooltipTemplate]="tooltipTemplate"
          [value]="chip"></app-chip>
        </span>
      }
    </div>
  }

  <div [attr.data-cy]="inputAndButtonWrapperDataCy" class="chip-input-and-button-wrapper">
    <div class="chip-input">

      @if (isAutocomplete) {
        <app-input-autocomplete #chipInputAutocomplete
          (inputValueChange)="setChip($event)"
          [baseCypressTag]="baseDataCy"
          [hasLabel]="false"
          [height]="INPUT_HEIGHT"
          [inputFormatter]="$safeNavigationMigration(autocompleteConfiguration?.inputFormatter)"
          [messages]="chipMessages"
          [placeholder]="inputPlaceholder"
          [resultFormatter]="$safeNavigationMigration(autocompleteConfiguration?.inputFormatter)"
          [resultTemplate]="resultTemplate"
          [resultsFunction]="$safeNavigationMigration(autocompleteConfiguration?.resultsFunction)"
        [validators]="state.configuration.chipInputValidator"></app-input-autocomplete>
      } @else {
        <app-input-text #chipInputText
          (inputValueChange)="setChip($event)"
          [baseCypressTag]="baseDataCy"
          [hasLabel]="false"
          [height]="INPUT_HEIGHT"
          [maxLength]=state.configuration.chipTextMaxLength
          [messages]="chipMessages"
          [placeholder]="inputPlaceholder"
        [validators]="state.configuration.chipInputValidator"></app-input-text>
      }
    </div>
    <app-tooltip [disable]="!hasMaxChipLength()" [dynamic]="false" [message]="maxLengthTooltipMessage()">
      <button (click)="onChipAdd()"
        [attr.data-cy]="addButtonDataCy"
        [disabled]="disableAddButton()"
        class="btn-secondary chip-add-button"
        >Add
      </button>
    </app-tooltip>
  </div>
</div>

